import { createSimpleStore } from "@expert/state-utils";

import type { C360Interaction } from "../api/interactions";

interface C360InteractionState {
    /** The C360 interaction recording each session, keyed by session ID. */
    sessions: Record<string, C360Interaction>;
}

interface C360InteractionActions {
    getInteraction: (sessionId: string) => C360Interaction | undefined;
    setInteraction: (sessionId: string, interaction: C360Interaction) => void;
    removeSession: (sessionId: string) => void;
}

type C360InteractionStore = C360InteractionState & C360InteractionActions;

export const useC360InteractionStore = createSimpleStore<C360InteractionStore>({
    devtools: {
        store: "c360Interaction",
        name: "workspace/c360-interaction",
        isProd: import.meta.env.VITE_ENV_TYPE === "production",
    },
    // Saved like the session store, so a page refresh mid-call still closes the line when the session ends.
    persist: { name: "c360-interaction-store", partialize: (state) => ({ sessions: state.sessions }) },
})((set, get) => ({
    sessions: {},
    getInteraction: (sessionId) => get().sessions[sessionId],
    setInteraction: (sessionId, interaction) =>
        set((state) => ({ sessions: { ...state.sessions, [sessionId]: interaction } }), false, "setInteraction"),
    removeSession: (sessionId) =>
        set(
            (state) => {
                const sessions = { ...state.sessions };
                delete sessions[sessionId];
                return { sessions };
            },
            false,
            "removeSession",
        ),
}));
